import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import TuneIcon from '@material-ui/icons/Tune';
import Button from '@material-ui/core/Button';
import Favorite from '@material-ui/icons/Favorite';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { useAuth } from '../contexts/AuthContext';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
    root: {
        '& h3': {
            margin: '5px 0',
        }
    },
    input: {
        width: 42,
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& > *': {
            margin: theme.spacing(1),
        },
        '& > div': {
            width: '100%',
            display: 'flex',
        },
        '& button': {
            flex: 1,
            '& svg': {
                marginLeft: 5,
            }
        }
    },
}));



export default function AddToCart(props) {
    const classes = useStyles();

    const product = props.product;
    const handleBadge = props.handleBadge;

    const [value, setValue] = React.useState(0);
    const [selectedCart, setSelectedCart] = useState(false);
    const [selectedWishlist, setSelectedWishlist] = useState(false);

    const { currentUser } = useAuth();

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? '' : Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > product.stock) {
            setValue(product.stock);
        }
    };


    const { enqueueSnackbar } = useSnackbar();
    const handleClickVariant = (message, variant) => {
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(message, { variant });
    };

    let [cart] = useState(
        JSON.parse(localStorage.getItem("TScart2")) || []
    );

    let exists = cart.filter(item => item.storageName === product.name);

    const handleCart = () => {
        if (currentUser) {
            for (let i = 0; i < cart.length; i++) {
                if (cart[i].storageName === product.name) {
                    setSelectedCart(!selectedCart);
                    cart.splice(i, 1);
                    localStorage.setItem("TScart2", JSON.stringify(cart));
                    handleClickVariant('Removed this product from the Cart.', 'error');
                    handleBadge();
                    return;
                }
            }
            if (value === 0 && product.stock > 0) {
                handleClickVariant('Add at least 1 product.', 'info');
                return;
            } else if (product.stock === 0) {
                handleClickVariant('This product is out of stock.', 'error');
                return;
            }
            cart.push({
                "storageName": product.name,
                "storageQuantity": value
            });
            setSelectedCart(!selectedCart);
            localStorage.setItem("TScart2", JSON.stringify(cart));
            handleClickVariant(`Added ${value} ${product.id} to the Cart.`, 'success');
            handleBadge();
        } else {
            handleClickVariant('You need to login first.', 'warning');
        }
    }

    let [wishlist] = useState(
        JSON.parse(localStorage.getItem("TSwishlist")) || []
    );

    let alreadyIs = wishlist.filter(item => item.storageName === product.name);

    const handleWishlist = () => {
        if (currentUser) {
            for (let i = 0; i < wishlist.length; i++) {
                if (wishlist[i].storageName === product.name) {
                    setSelectedWishlist(!selectedWishlist);
                    wishlist.splice(i, 1);
                    localStorage.setItem("TSwishlist", JSON.stringify(wishlist));
                    handleClickVariant('Removed this product from the Wishlist.', 'error');
                    handleBadge();
                    return;
                }
            }
            wishlist.push({
                "storageName": product.name
            });
            setSelectedWishlist(!selectedWishlist);
            localStorage.setItem("TSwishlist", JSON.stringify(wishlist));
            handleClickVariant(`Added ${product.id} to the Wishlist.`, 'success');
            handleBadge();
        } else {
            handleClickVariant('You need to login first.', 'warning');
        }
    }


    return (
        <section className={classes.root}>
            <div>
                <small>In stock:
                    <span> {product.stock}</span>
                </small>
                <h3>Price:
                    <strong style={{ color: '#ff5722' }}>
                        <span> {product.price.toLocaleString("ro")} </span>RON
                    </strong>
                </h3>
            </div>
            <div>
                <Typography gutterBottom>Quantity:</Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <TuneIcon color="primary" fontSize="default" />
                    </Grid>
                    <Grid item xs>
                        <Slider
                            value={typeof value === 'number' ? value : 0}
                            onChange={handleSliderChange}
                            aria-labelledby="input-slider"
                            max={product.stock}
                        />
                    </Grid>
                    <Grid item>
                        <Input
                            className={classes.input}
                            value={value}
                            margin="dense"
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            inputProps={{
                                step: 1,
                                min: 0,
                                max: product.stock,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                        />
                    </Grid>
                </Grid>

                <div className={classes.buttons}>
                    <Button variant="contained" color="primary" style={{ padding: 0 }}>
                        <ToggleButton
                            selected={selectedCart}
                            onChange={handleCart}
                        >
                            <Typography style={{ color: 'white' }} >Add to Cart</Typography>
                            {exists.length > 0 && currentUser ? <ShoppingCartIcon style={{ color: 'lightgreen' }} /> : <ShoppingCartIcon />}
                        </ToggleButton>
                    </Button>
                    <Button variant="contained" style={{ padding: 0 }}>
                        <ToggleButton
                            selected={selectedWishlist}
                            onChange={handleWishlist}
                        >
                            <Typography style={{ color: 'white' }} >Add to Wishlist</Typography>
                            {alreadyIs.length > 0 && currentUser ? <Favorite color="secondary" /> : <Favorite />}
                        </ToggleButton>
                    </Button>

                </div>
            </div>
        </section >
    )
}
